<div *ngIf="userInfo" style="padding-right: 20px">
    <pandora-aside #searchAside [title]="'Search'" [isToggleAvailable]=true [isToggleButtonExists]=true>
        <div aside-content><kpi-search></kpi-search></div>
    </pandora-aside>

    <div class="kpi-charts">
        <div class="kpi-row" (click)="getKpiInfo()">
            <div class="column" >
                <h4>Total Lab {{searchCriteria.submissionIdentifierType}} By Year</h4>
                <kpi-line-chart [userInfo]="userInfo"  [data]="perYear" [xAxisLabel]="xSubmissionsPerYearLabel" [yAxisLabel]="ySubmissionsPerYearLabel" [graphTitle]="submissionsPerYearTitle"></kpi-line-chart>
            </div>
            <div class="column">
                <h4>{{searchCriteria.submissionIdentifierType}} Breakdown By Month</h4>
                <kpi-line-chart [userInfo]="userInfo"  [data]="perMonth" [xAxisLabel]="xSubmissionsPerMonthLabel" [yAxisLabel]="ySubmissionsPerMonthLabel" [graphTitle]="submissionsPerMonthTitle"></kpi-line-chart>
            </div>
            <div class="column">
                <h4>{{searchCriteria.submissionIdentifierType}} Breakdown By Day</h4>
                <kpi-line-chart [userInfo]="userInfo"  [data]="perDay" [xAxisLabel]="xSubmissionsPerDayLabel" [yAxisLabel]="ySubmissionsPerDayLabel" [graphTitle]="submissionsPerDayTitle"></kpi-line-chart>
            </div>
        </div>

        <div class="kpi-row">
            <div class="column">
                <h4>{{searchCriteria.submissionIdentifierType}} Breakdown By Project Name</h4>
                <kpi-bar-chart [userInfo]="userInfo" [data]="perProject" [xAxisLabel]="xSubmissionsPerProjectLabel" [yAxisLabel]="ySubmissionsPerProjectLabel" [graphTitle]="submissionsPerProjectTitle"></kpi-bar-chart>
            </div>
            <div class="column">
                <h4>{{searchCriteria.submissionIdentifierType}} Breakdown By Reporting Center</h4>
                <kpi-bar-chart [userInfo]="userInfo" [data]="perCenter" [xAxisLabel]="xSubmissionsPerCenterLabel" [yAxisLabel]="ySubmissionsPerCenterLabel" [graphTitle]="submissionsPerCenterTitle"></kpi-bar-chart>
            </div>
            <div class="column">
                <h4>{{searchCriteria.submissionIdentifierType}} Breakdown By Test Type</h4>
                <kpi-pie-chart [userInfo]="userInfo" [data]="perTestType" [graphTitle]=""></kpi-pie-chart>
            </div>
        </div>
    </div>
</div>

